import { useEffect, useState } from 'react';
import { getAppVersion } from 'app/console-api';
import { PageFooter } from './page-footer';

export const VersionedFooter = () => {
  const [version, setVersion] = useState('0.0.0');

  useEffect(() => {
    getAppVersion()
      .then((response) => {
        setVersion(response.release);
      })
      .catch((error) => {
        console.error('Failed to fetch version:', error);
      });
  }, []);

  return <PageFooter version={version} />;
};
